/**
 * reducers/recruit.js
 */

const initialState = {
  result: undefined,
  error: false
}
export default (state = initialState,action) => {
  switch (action.type){
    case 'RECIVE_DATA':
      return {
        result:action.payload.status,
        error:false
      }
      default:
        return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/recruit.js